<template>

    <v-app id="user-page">

        <v-app-bar app height="130" elevation="0">

            <v-app-bar-nav-icon @click="drawer = !drawer" class="ml-3"></v-app-bar-nav-icon>

            <a @click="$router.push({ name: 'Accounts' })" class="logo-animation ml-3" v-if="logoUrl === null">
                <img class="logo-symbol" src="assets/img/einstein-animation.gif" title="EinsteinFI" alt="EinsteinFI" />
                <img class="logo-text" src="assets/img/logo-header-text-only.svg" title="EinsteinFI" alt="EinsteinFI" />
            </a>

            <a @click="$router.push({ name: 'Accounts' })" class="ml-3" v-else>
                <img class="logo-symbol"  style="height: 100px;" :src="logoUrl" />
            </a>

            <h1 class="text-headline">
                Plan and <span class="text-bold">Invest <span class="text-blue">Smarter.</span></span>
            </h1>

            <div style="flex-grow: 1"></div>

            <v-card class="px-3 py-2 text-center" tile elevation="0" color="transparent">
<!--                <p v-if="$store.state.auth.adminMode" style="color:red;">Admin Mode</p>-->
<!--                <p><a-->
<!--                    v-if="$store.state.auth.adminMode"-->
<!--                    :href="$api_url + '/households/' + $store.state.auth.user.household_id">Back to Einstein</a>-->
<!--                </p>-->
                <div class="font-weight-bold">Welcome,
                    <div v-if="personTwoExists">{{ user.fname }} and {{ personTwo.name }} {{ personTwo.lname }}</div>
                    <div v-else>{{ user.fname }} {{ user.lname }}</div>
                </div>
            </v-card>


        </v-app-bar>

        <v-navigation-drawer v-model="drawer" app temporary width="320">

            <v-card class="px-3 user-card" tile elevation="0" color="transparent">
                <p v-if="adminMode" style="color:red;">Admin Mode</p>
                <a
                    v-if="adminMode"
                    @click="backToAdmin">Back to Einstein</a>
                <p class="user-welcome">Welcome,</p>
                <p class="user-name" v-if="personTwoExists">{{ user.fname }} and {{ personTwo.name }} {{ user.lname }}</p>
                <p class="user-name" v-else>{{ user.fname }} {{ user.lname }}</p>
                <p class="advisor-name"><v-icon>mdi-account</v-icon> {{ advisor.fname }} {{ advisor.lname }}</p>

                <p class="advisor-email" v-if="clientPortalSetting.email">
                    <v-icon>mdi-email</v-icon>
                    <a :href="'mailto:' + clientPortalSetting.email">
                        {{ clientPortalSetting.email }}
                    </a>
                </p>

                <p class="advisor-email" v-if="clientPortalSetting.phone_number" style="font-family: 'Roboto, sans-serif;'">
                    <v-icon>mdi-phone</v-icon>
                    <a :href="'tel:' + clientPortalSetting.phone_number">
                        {{ clientPortalSetting.phone_number | phone }}
                    </a>
                </p>

                <p class="advisor-email" v-if="clientPortalSetting.schedule_meetings_link">
                    <v-icon>mdi-calendar-blank-multiple</v-icon>
                    <a
                        target="_blank"
                        :href="link(clientPortalSetting.schedule_meetings_link)"> Schedule a meeting</a>
                </p>

                <p class="advisor-email" v-if="clientPortalSetting.calendar_link">
                    <v-icon>mdi-calendar-month</v-icon>
                    <a
                        target="_blank"
                        :href="link(clientPortalSetting.calendar_link)"> Calendar</a>
                </p>

                <p class="advisor-spacer"></p>
            </v-card>

            <v-divider
                    class="mx-6"
            ></v-divider>

            <v-card class="px-3" tile elevation="0" color="transparent">
                <navigation
                    :draggable-menus="orderedMenu"
                    @navigationMenuOrderUpdated="(payload) => setNavigationOrder({payload})"/>
            </v-card>

        </v-navigation-drawer>

        <v-main>
            <v-container fluid class="grey lighten-4 fill-height align-content-space-between">
                <v-row justify="center" align="center" class="align-start">
                    <v-col class="px-6 py-4">
                        <loader v-if="loading" />
                        <slot v-else></slot>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center" v-if="!loading" class="align-end">
                    <v-col class="ml-6 mr-6 py-4 col" style="border-top: lightgray solid 1px;">
                        <slot name="disclosure">
                            <div v-html="company.disclosure_client_portal"></div>
                        </slot>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>

        <cookie-banner v-if="!adminMode"/>

        <v-dialog
            width="640"
            scrollable
            persistent
            no-click-animation
            v-model="showTermsOfService"
        >
            <terms-of-service-modal />
        </v-dialog>

        <v-dialog
            width="640"
            scrollable
            persistent
            no-click-animation
            v-model="showNewsletterModal"
        >
            <new-newsletter-notification-modal />
        </v-dialog>
    </v-app>

</template>

<script>
    import {mapGetters, mapState, mapActions} from "vuex";
    import Loader from "@/components/Loader";
    import TermsOfServiceModal from "@/components/modal/TermsOfServiceModal";
    import NewNewsletterNotificationModal from "@/components/modal/NewNewsletterNotificationModal";

    import CookieBanner from "@/components/CookieBanner";
    import Navigation from "@/components/Navigation";

    export default {
        components: {
            Loader,
            TermsOfServiceModal,
            NewNewsletterNotificationModal,
            CookieBanner,
            Navigation
        },
        computed: {
            ...mapGetters('auth', [
                'user',
                'showTermsOfService',
                'showNewsletterModal'
            ]),
            ...mapGetters('draggableNavigation', [
                'orderedMenu'
            ]),
            ...mapState('advisor', [
                'advisor',
            ]),
            ...mapState('auth', [
                'adminMode',
                'clientPortalSetting'
            ]),
            ...mapGetters('settings', [
                'getTooltipText'
            ]),
            ...mapGetters('individuals', [
                'personTwo',
                'personTwoExists',
            ]),
            ...mapGetters('company', [
                'company',
                'logoUrl',
            ]),
            ...mapState('household', [
               'household'
            ]),
            ...mapState('loader', ['loading']),

            link() {
                return (link) => {
                    if (link && !link.includes('https://')) {
                        return 'https://' + link;
                    }

                    return link;
                }
            }
        },

        data: () => ({
            cookiesMsg: true,
            drawer: false
        }),

        methods: {
            ...mapActions('auth', [
                'setNavigationOrder',
                'logoutAdmin'
            ]),
            backToAdmin() {
                let householdId = this.$store.state.auth.user.household_id;
                this.logoutAdmin().then(() => {
                    window.location = this.$api_url + '/households/' + householdId;
                })

            }
        },

        created() {
            window.scrollTo(0, 0);
        },

        watch: {
            user() {
                this.$store.dispatch('household/fetchHousehold', this.user.household_id);
            }
        },
    }
</script>

<style scoped>
.user-card a {
    color: unset;
    text-decoration: none;
}
</style>
